import { Component, Input, SkipSelf, Optional, Output, EventEmitter } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { ValueTypeEnum } from '../designer-config-service/appconfig/app-config-designer';

@Component({
  selector: 'datex-common-value-control',
  templateUrl: './value-control.component.html',
  styleUrls: ['./value-control.component.scss'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]],
  }],
  standalone: false
})
export class ValueControlComponent {

  valueTypeBoolean = ValueTypeEnum.boolean;
  valueTypeDate = ValueTypeEnum.date;
  valueTypeNumber = ValueTypeEnum.number;
  valueTypeString = ValueTypeEnum.string;
  valueTypeTime = ValueTypeEnum.time;

  @Input() valueType: ValueTypeEnum;
  @Input() valueJson: unknown;
  @Input() groupName = 'valueControlGroup';
  @Input() readOnly: boolean;

  @Output() valueJsonChange: EventEmitter<unknown> = new EventEmitter<unknown>();

  get ready(): boolean {
    return !!this.valueType;
  }

  scalarValueGet() {
    return this.valueJson;
  }

  scalarValueSet(value: unknown) {
    this.valueJson = value;
    this.valueJsonChange.emit(this.valueJson);
  }
}

